import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import {SliderArrow} from 'components/shared';
import React, {FC, PropsWithChildren, useRef} from 'react';
import type {Swiper as SwiperType} from 'swiper';
import {A11y, Autoplay, Keyboard, Navigation, Pagination} from 'swiper/modules';
import {Swiper, SwiperSlide} from 'swiper/react';

import {Container} from './Slider.styled';

type Props = {
  slidesToShow?: number;
  dots?: boolean;
  autoplaySpeed?: number;
  autoplay?: boolean;
  centerMode?: boolean;
  slidesToScroll?: number;
  infinite?: boolean;
  speed?: number;
};

export const Slider: FC<PropsWithChildren<Props>> = React.memo((props) => {
  const swiperRef = useRef<SwiperType | null>(null);

  const handlePrev = () => {
    swiperRef.current?.slidePrev();
  };

  const handleNext = () => {
    swiperRef.current?.slideNext();
  };

  const childrenArray = React.Children.toArray(props.children);
  const itemCount = childrenArray.length;
  const shouldLoop = props.infinite !== undefined ? props.infinite : itemCount > 1;

  return (
    <Container>
      <SliderArrow variant="left" onClick={handlePrev} />
      <SliderArrow variant="right" onClick={handleNext} />
      <Swiper
        onSwiper={(swiper) => {
          swiperRef.current = swiper;
        }}
        modules={[Navigation, Pagination, Autoplay, Keyboard, A11y]}
        slidesPerView={props.slidesToShow || 1}
        spaceBetween={0}
        loop={shouldLoop}
        speed={props.speed || 1000}
        autoplay={
          props.autoplay
            ? {
                delay: props.autoplaySpeed || 3000,
                pauseOnMouseEnter: true,
                disableOnInteraction: false,
              }
            : false
        }
        pagination={props.dots ? {clickable: true} : false}
        keyboard={{enabled: true}}
        a11y={{
          prevSlideMessage: 'Previous slide',
          nextSlideMessage: 'Next slide',
          firstSlideMessage: 'This is the first slide',
          lastSlideMessage: 'This is the last slide',
        }}
      >
        {childrenArray.map((child, index) => (
          <SwiperSlide key={index}>{child}</SwiperSlide>
        ))}
      </Swiper>
    </Container>
  );
});
